<template>
  <div class="page-content">
   <div class="container-fluid">
      <!-- start page title -->
      <div class="row">
         <div class="col-12">
            <div class="page-title-box d-flex align-items-center justify-content-between">
               <h4 class="mb-0 font-size-18">Checkout</h4>
               <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                     <li class="breadcrumb-item"><a href="javascript: void(0);">Home</a></li>
                     <li class="breadcrumb-item active">Checkout</li>
                  </ol>
               </div>
            </div>
         </div>
      </div>
      <!-- end page title -->
      <div class="row">
         <div class="col-lg-12">
            <div class="card">
               <div class="card-body">
                  <h4 class="card-title">Order Summary</h4>
                  <p class="card-title-desc"></p>
                  <div class="row">
                     <div class="col-lg-6">
                        <div class="table-responsive">
                           <table class="table table-centered mb-0 table-nowrap">
                              <thead class="thead-light">
                                 <tr>
                                    <th>Service Description</th>
                                    <th colspan="2">Price</th>
                                 </tr>
                              </thead>
                              <tbody>
                                 <tr>
                                    <td>
                                       <h5 class="font-size-14 text-truncate"><a href="ecommerce-product-detail.html" class="text-dark">1GB Plan</a></h5>
                                    </td>
                                    <td>
                                       £3.98
                                    </td>
                                 </tr>
                              </tbody>
                           </table>
                        </div>
                     </div>
                     <div class="col-lg-6">
                        <div class="mt-4 mt-lg-0">
                           <div class="card">
                              <div class="card-body">
                                 <h4 class="card-title mb-3">Review Your Order</h4>
                                 <div class="table-responsive">
                                    <table class="table mb-0">
                                       <tbody>
                                          <tr>
                                             <td>Estimated VAT : </td>
                                             <td><i>Included in Price</i></td>
                                          </tr>
                                          <tr>
                                             <th>Total Due:</th>
                                             <th>£3.98</th>
                                          </tr>
                                       </tbody>
                                    </table>
                                 </div>
                                 <!-- end table-responsive -->
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <!-- end row -->
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <h4 class="card-title">Billing Information</h4>
                  <p class="card-title-desc">Please fill out the following information below</p>
                  <div class="form-group row">
                     <label for="example-text-input" class="col-md-2 col-form-label">Full Name</label>
                     <div class="col-md-10">
                        <input class="form-control" type="text" placeholder="Enter your name" id="example-text-input">
                     </div>
                  </div>
                  <div class="form-group row">
                     <label for="example-text-input" class="col-md-2 col-form-label">Phone</label>
                     <div class="col-md-10">
                        <input class="form-control" type="text" placeholder="Enter your phone number" id="example-text-input">
                     </div>
                  </div>
                  <div class="form-group row">
                     <label for="billing-address" class="col-md-2 col-form-label">Address</label>
                     <div class="col-md-10">
                        <textarea class="form-control" id="billing-address" rows="3" placeholder="Enter street address"></textarea>
                     </div>
                  </div>
                  <div class="form-group row">
                     <label for="example-text-input" class="col-md-2 col-form-label">City</label>
                     <div class="col-md-10">
                        <input class="form-control" type="text" id="example-text-input">
                     </div>
                  </div>
                  <div class="form-group row">
                     <label for="example-text-input" class="col-md-2 col-form-label">State/Region</label>
                     <div class="col-md-10">
                        <input class="form-control" type="text" id="example-text-input">
                     </div>
                  </div>
                  <div class="form-group row">
                     <label for="example-text-input" class="col-md-2 col-form-label">Zip Code</label>
                     <div class="col-md-10">
                        <input class="form-control" type="text" id="example-text-input">
                     </div>
                  </div>
                  <div class="form-group row">
                     <label class="col-md-2 col-form-label">Country</label>
                     <div class="col-md-10">
                        <select class="form-control select2" title="Country">
                           <option value="0">Select Country</option>
                           <option value="AF">Afghanistan</option>
                           <option value="AL">Albania</option>
                           <option value="DZ">Algeria</option>
                           <option value="AS">American Samoa</option>
                           <option value="AD">Andorra</option>
                           <option value="AO">Angola</option>
                           <option value="AI">Anguilla</option>
                           <option value="AQ">Antarctica</option>
                           <option value="AR">Argentina</option>
                           <option value="AM">Armenia</option>
                           <option value="AW">Aruba</option>
                           <option value="AU">Australia</option>
                           <option value="AT">Austria</option>
                           <option value="AZ">Azerbaijan</option>
                           <option value="BS">Bahamas</option>
                           <option value="BH">Bahrain</option>
                           <option value="BD">Bangladesh</option>
                           <option value="BB">Barbados</option>
                           <option value="BY">Belarus</option>
                           <option value="BE">Belgium</option>
                           <option value="BZ">Belize</option>
                           <option value="BJ">Benin</option>
                           <option value="BM">Bermuda</option>
                           <option value="BT">Bhutan</option>
                           <option value="BO">Bolivia</option>
                           <option value="BW">Botswana</option>
                           <option value="BV">Bouvet Island</option>
                           <option value="BR">Brazil</option>
                           <option value="BN">Brunei Darussalam</option>
                           <option value="BG">Bulgaria</option>
                           <option value="BF">Burkina Faso</option>
                           <option value="BI">Burundi</option>
                           <option value="KH">Cambodia</option>
                           <option value="CM">Cameroon</option>
                           <option value="CA">Canada</option>
                           <option value="CV">Cape Verde</option>
                           <option value="KY">Cayman Islands</option>
                           <option value="CF">Central African Republic</option>
                           <option value="TD">Chad</option>
                           <option value="CL">Chile</option>
                           <option value="CN">China</option>
                           <option value="CX">Christmas Island</option>
                           <option value="CC">Cocos (Keeling) Islands</option>
                           <option value="CO">Colombia</option>
                           <option value="KM">Comoros</option>
                           <option value="CG">Congo</option>
                           <option value="CK">Cook Islands</option>
                           <option value="CR">Costa Rica</option>
                           <option value="CI">Cote d'Ivoire</option>
                           <option value="HR">Croatia (Hrvatska)</option>
                           <option value="CU">Cuba</option>
                           <option value="CY">Cyprus</option>
                           <option value="CZ">Czech Republic</option>
                           <option value="DK">Denmark</option>
                           <option value="DJ">Djibouti</option>
                           <option value="DM">Dominica</option>
                           <option value="DO">Dominican Republic</option>
                           <option value="EC">Ecuador</option>
                           <option value="EG">Egypt</option>
                           <option value="SV">El Salvador</option>
                           <option value="GQ">Equatorial Guinea</option>
                           <option value="ER">Eritrea</option>
                           <option value="EE">Estonia</option>
                           <option value="ET">Ethiopia</option>
                           <option value="FK">Falkland Islands (Malvinas)</option>
                           <option value="FO">Faroe Islands</option>
                           <option value="FJ">Fiji</option>
                           <option value="FI">Finland</option>
                           <option value="FR">France</option>
                           <option value="GF">French Guiana</option>
                           <option value="PF">French Polynesia</option>
                           <option value="GA">Gabon</option>
                           <option value="GM">Gambia</option>
                           <option value="GE">Georgia</option>
                           <option value="DE">Germany</option>
                           <option value="GH">Ghana</option>
                           <option value="GI">Gibraltar</option>
                           <option value="GR">Greece</option>
                           <option value="GL">Greenland</option>
                           <option value="GD">Grenada</option>
                           <option value="GP">Guadeloupe</option>
                           <option value="GU">Guam</option>
                           <option value="GT">Guatemala</option>
                           <option value="GN">Guinea</option>
                           <option value="GW">Guinea-Bissau</option>
                           <option value="GY">Guyana</option>
                           <option value="HT">Haiti</option>
                           <option value="HN">Honduras</option>
                           <option value="HK">Hong Kong</option>
                           <option value="HU">Hungary</option>
                           <option value="IS">Iceland</option>
                           <option value="IN">India</option>
                           <option value="ID">Indonesia</option>
                           <option value="IQ">Iraq</option>
                           <option value="IE">Ireland</option>
                           <option value="IL">Israel</option>
                           <option value="IT">Italy</option>
                           <option value="JM">Jamaica</option>
                           <option value="JP">Japan</option>
                           <option value="JO">Jordan</option>
                           <option value="KZ">Kazakhstan</option>
                           <option value="KE">Kenya</option>
                           <option value="KI">Kiribati</option>
                           <option value="KR">Korea, Republic of</option>
                           <option value="KW">Kuwait</option>
                           <option value="KG">Kyrgyzstan</option>
                           <option value="LV">Latvia</option>
                           <option value="LB">Lebanon</option>
                           <option value="LS">Lesotho</option>
                           <option value="LR">Liberia</option>
                           <option value="LY">Libyan Arab Jamahiriya</option>
                           <option value="LI">Liechtenstein</option>
                           <option value="LT">Lithuania</option>
                           <option value="LU">Luxembourg</option>
                           <option value="MO">Macau</option>
                           <option value="MG">Madagascar</option>
                           <option value="MW">Malawi</option>
                           <option value="MY">Malaysia</option>
                           <option value="MV">Maldives</option>
                           <option value="ML">Mali</option>
                           <option value="MT">Malta</option>
                           <option value="MH">Marshall Islands</option>
                           <option value="MQ">Martinique</option>
                           <option value="MR">Mauritania</option>
                           <option value="MU">Mauritius</option>
                           <option value="YT">Mayotte</option>
                           <option value="MX">Mexico</option>
                           <option value="MD">Moldova, Republic of</option>
                           <option value="MC">Monaco</option>
                           <option value="MN">Mongolia</option>
                           <option value="MS">Montserrat</option>
                           <option value="MA">Morocco</option>
                           <option value="MZ">Mozambique</option>
                           <option value="MM">Myanmar</option>
                           <option value="NA">Namibia</option>
                           <option value="NR">Nauru</option>
                           <option value="NP">Nepal</option>
                           <option value="NL">Netherlands</option>
                           <option value="AN">Netherlands Antilles</option>
                           <option value="NC">New Caledonia</option>
                           <option value="NZ">New Zealand</option>
                           <option value="NI">Nicaragua</option>
                           <option value="NE">Niger</option>
                           <option value="NG">Nigeria</option>
                           <option value="NU">Niue</option>
                           <option value="NF">Norfolk Island</option>
                           <option value="MP">Northern Mariana Islands</option>
                           <option value="NO">Norway</option>
                           <option value="OM">Oman</option>
                           <option value="PW">Palau</option>
                           <option value="PA">Panama</option>
                           <option value="PG">Papua New Guinea</option>
                           <option value="PY">Paraguay</option>
                           <option value="PE">Peru</option>
                           <option value="PH">Philippines</option>
                           <option value="PN">Pitcairn</option>
                           <option value="PL">Poland</option>
                           <option value="PT">Portugal</option>
                           <option value="PR">Puerto Rico</option>
                           <option value="QA">Qatar</option>
                           <option value="RE">Reunion</option>
                           <option value="RO">Romania</option>
                           <option value="RU">Russian Federation</option>
                           <option value="RW">Rwanda</option>
                           <option value="KN">Saint Kitts and Nevis</option>
                           <option value="LC">Saint LUCIA</option>
                           <option value="WS">Samoa</option>
                           <option value="SM">San Marino</option>
                           <option value="ST">Sao Tome and Principe</option>
                           <option value="SA">Saudi Arabia</option>
                           <option value="SN">Senegal</option>
                           <option value="SC">Seychelles</option>
                           <option value="SL">Sierra Leone</option>
                           <option value="SG">Singapore</option>
                           <option value="SK">Slovakia (Slovak Republic)</option>
                           <option value="SI">Slovenia</option>
                           <option value="SB">Solomon Islands</option>
                           <option value="SO">Somalia</option>
                           <option value="ZA">South Africa</option>
                           <option value="ES">Spain</option>
                           <option value="LK">Sri Lanka</option>
                           <option value="SH">St. Helena</option>
                           <option value="PM">St. Pierre and Miquelon</option>
                           <option value="SD">Sudan</option>
                           <option value="SR">Suriname</option>
                           <option value="SZ">Swaziland</option>
                           <option value="SE">Sweden</option>
                           <option value="CH">Switzerland</option>
                           <option value="SY">Syrian Arab Republic</option>
                           <option value="TW">Taiwan, Province of China</option>
                           <option value="TJ">Tajikistan</option>
                           <option value="TZ">Tanzania, United Republic of</option>
                           <option value="TH">Thailand</option>
                           <option value="TG">Togo</option>
                           <option value="TK">Tokelau</option>
                           <option value="TO">Tonga</option>
                           <option value="TT">Trinidad and Tobago</option>
                           <option value="TN">Tunisia</option>
                           <option value="TR">Turkey</option>
                           <option value="TM">Turkmenistan</option>
                           <option value="TC">Turks and Caicos Islands</option>
                           <option value="TV">Tuvalu</option>
                           <option value="UG">Uganda</option>
                           <option value="UA">Ukraine</option>
                           <option value="AE">United Arab Emirates</option>
                           <option value="GB">United Kingdom</option>
                           <option value="US">United States</option>
                           <option value="UY">Uruguay</option>
                           <option value="UZ">Uzbekistan</option>
                           <option value="VU">Vanuatu</option>
                           <option value="VE">Venezuela</option>
                           <option value="VN">Viet Nam</option>
                           <option value="VG">Virgin Islands (British)</option>
                           <option value="VI">Virgin Islands (U.S.)</option>
                           <option value="WF">Wallis and Futuna Islands</option>
                           <option value="EH">Western Sahara</option>
                           <option value="YE">Yemen</option>
                           <option value="ZM">Zambia</option>
                           <option value="ZW">Zimbabwe</option>
                        </select>
                     </div>
                  </div>
                  <div class="form-group row">
                     <label class="col-md-2 col-form-label">How did you find us?</label>
                     <div class="col-md-10">
                        <select class="form-control">
                           <option>Google</option>
                           <option>MC-Market</option>
                           <option>Word of mouth</option>
                           <option>Other</option>
                        </select>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <!-- end col -->
      </div>
      <!-- end row -->
      <div class="row">
         <div class="col-lg-6">
            <div class="card">
               <div class="card-body">
                  <h4 class="card-title">Promotional Code</h4>
                  <p class="card-title-desc">Have a promotional code? Enter it here.</p>
                  <div>
                     <div class="input-group mb-4">
                        <input class="form-control" type="text" placeholder="Enter promo code here">
                        <div class="input-group-prepend">
                           <button type="button" class="btn btn-light waves-effect">Validate</button>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <div class="col-lg-6">
            <div class="card">
               <div class="card-body">
                  <h4 class="card-title">Payment Methods</h4>
                  <p class="card-title-desc">Select your preferred payment method.</p>
                  <div>
                     <div class="custom-control custom-radio custom-control-inline mr-4">
                        <input type="radio" id="customRadioInline2" name="customRadioInline1" class="custom-control-input" checked>
                        <label class="custom-control-label" for="customRadioInline2"><i class="fab fa-cc-paypal mr-1 font-size-20 align-top"></i> PayPal</label><br><br>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <!-- end row -->
      <div class="row">
         <div class="col-lg-12">
            <div class="card">
               <div class="card-body">
                  <h4 class="card-title">Terms of Service</h4>
                  <p class="card-title-desc">Please read and accept the following to continue.</p>
                  <div class="row">
                     <div class="col-lg-6">
                        <div class="custom-control custom-checkbox mb-3">
                           <input type="checkbox" class="custom-control-input" id="terms">
                           <label class="custom-control-label" for="terms">I have read and agree to the <a href="#">Terms of Service</a></label>
                        </div>
                        <div class="custom-control custom-checkbox mb-3">
                           <input type="checkbox" class="custom-control-input" id="acceptableuse">
                           <label class="custom-control-label" for="acceptableuse">I have read and agree to the <a href="#">Acceptable Use Policy</a></label>
                        </div>
                        <div class="custom-control custom-checkbox mb-3">
                           <input type="checkbox" class="custom-control-input" id="privacypolicy">
                           <label class="custom-control-label" for="privacypolicy">I have read and agree to the <a href="#">Privacy Policy</a></label>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <!-- end row -->
      <!-- end row -->
      <div class="row my-4">
         <div class="col-sm-6">
            <a href="pricing.html" class="btn text-muted d-none d-sm-inline-block btn-link">
            <i class="mdi mdi-arrow-left mr-1"></i> Select Different Plan </a>
         </div>
         <!-- end col -->
         <div class="col-sm-6">
            <div class="text-sm-right">
               <a href="#" class="btn btn-primary">
               <i class="bx bxl-paypal mr-1"></i> Continue to PayPal </a>
            </div>
         </div>
         <!-- end col -->
      </div>
   </div>
</div>
</template>

<script>
export default{
  name: 'Checkout',
  data () {
    return { }
  }
}</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/management/billing/Checkout.vue